import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'molla-new-collection',
  templateUrl: './new-collection.component.html',
  styleUrls: ['./new-collection.component.scss']
})
export class NewCollectionComponent implements OnInit {

  @Input() products = [];
	@Input() loaded = false;
  
  constructor() { }

  ngOnInit(): void {
  }

}
